import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useInvoice } from '../context/InvoiceContext';

const { FiChevronDown, FiUser } = FiIcons;

const CustomerSelector = ({ customer, onChange }) => {
  const { savedCustomers } = useInvoice();
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleCustomerSelect = (savedCustomer) => {
    Object.keys(savedCustomer).forEach(key => {
      if (key !== 'id') {
        onChange(key, savedCustomer[key]);
      }
    });
    setShowSuggestions(false);
  };

  const filteredCustomers = savedCustomers.filter(cust =>
    cust.name.toLowerCase().includes(customer.name.toLowerCase()) ||
    cust.email.toLowerCase().includes(customer.name.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Customer Name
        </label>
        <div className="relative">
          <input
            type="text"
            value={customer.name}
            onChange={(e) => {
              onChange('name', e.target.value);
              setShowSuggestions(e.target.value.length > 0);
            }}
            onFocus={() => setShowSuggestions(customer.name.length > 0)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-10"
            placeholder="Enter customer name"
            required
          />
          {savedCustomers.length > 0 && (
            <button
              type="button"
              onClick={() => setShowSuggestions(!showSuggestions)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              <SafeIcon icon={FiChevronDown} className="w-4 h-4" />
            </button>
          )}
        </div>

        <AnimatePresence>
          {showSuggestions && filteredCustomers.length > 0 && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-40 overflow-y-auto"
            >
              {filteredCustomers.map((cust) => (
                <motion.button
                  key={cust.id}
                  type="button"
                  onClick={() => handleCustomerSelect(cust)}
                  className="w-full text-left px-4 py-3 hover:bg-gray-50 border-b border-gray-100 last:border-b-0 flex items-start space-x-3"
                  whileHover={{ backgroundColor: '#f9fafb' }}
                >
                  <SafeIcon icon={FiUser} className="w-4 h-4 text-gray-400 mt-1 flex-shrink-0" />
                  <div>
                    <div className="font-medium text-gray-900">{cust.name}</div>
                    <div className="text-sm text-gray-500">{cust.email}</div>
                    <div className="text-sm text-gray-500 truncate">{cust.address}</div>
                  </div>
                </motion.button>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email
          </label>
          <input
            type="email"
            value={customer.email}
            onChange={(e) => onChange('email', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="customer@example.com"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Phone
          </label>
          <input
            type="tel"
            value={customer.phone}
            onChange={(e) => onChange('phone', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="+1 (555) 000-0000"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Address
        </label>
        <textarea
          value={customer.address}
          onChange={(e) => onChange('address', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Enter customer address"
          required
        />
      </div>
    </div>
  );
};

export default CustomerSelector;